var userAgent = navigator.userAgent,
	rMsie = /(msie\s|trident.*rv:)([\w.]+)/,
	rFirefox = /(firefox)\/([\w.]+)/,
	rOpera = /(opera).+version\/([\w.]+)/,
	rChrome = /(chrome)\/([\w.]+)/,
	rSafari = /version\/([\w.]+).*(safari)/;
var browser;
var version;
var ua = userAgent.toLowerCase();
function uaMatch(ua) {
	var match = rMsie.exec(ua);
	if (match != null) {
		return { browser: "IE", version: match[2] || "0" };
	}
	var match = rFirefox.exec(ua);
	if (match != null) {
		return { browser: match[1] || "", version: match[2] || "0" };
	}
	var match = rOpera.exec(ua);
	if (match != null) {
		return { browser: match[1] || "", version: match[2] || "0" };
	}
	var match = rChrome.exec(ua);
	if (match != null) {
		return { browser: match[1] || "", version: match[2] || "0" };
	}
	var match = rSafari.exec(ua);
	if (match != null) {
		return { browser: match[2] || "", version: match[1] || "0" };
	}
	if (match != null) {
		return { browser: "", version: "0" };
	}
}
var browserMatch = uaMatch(userAgent.toLowerCase());
if (browserMatch.browser) {
	browser = browserMatch.browser;
	version = browserMatch.version;
}

var str = '';

var copyright = '乐山市财政局[专用];V5.0S0xGAAEAAAAAAAAAEAAAADsBAABAAQAALAAAANTBO+vmYqtd3ceKO8igYr7YzgvpidbYILjC7/FvtZiw1ZyUnyYsAqYEAf5UiNOCuwXy0ge+mDMNqM7rvEjxJGUC/OW/iprZgWfF6dITFqTFytC054KNuIOdzCx+y0PAs2zVMscPQ87J1846ySBXTgnu3D5AyiXGf/ADM5iyvbp11oLNASJgIosfYbZRJ1uoiDAsdKTcaGFpvayI7p2aSDlxJPy6kmbAhM8QopprI2Zmv6lCRwag5z7JefCI2wwrY9jlmeACvjirrLft5xCTkGan+gtcy43EqYgyOzo9LtZ5yBfD3/8/1zLdyI3uaBCNTFi6vZNhW3eD2Dxom6xBoAnZseuFIVp78DzCcoKAO2XM5Vvnsp6va+uoTHOGrm6lAp9YGci08rjhxk11l7hkF7YfG4q9geMEkv4wRJvrcHnb9PqD82ym77w0pxgT9deKjg==';

var copyright_zukk = '乐山市财政局[专用];V5.0S0xGAAEAAAAAAAAAEAAAAEQBAABQAQAALAAAAJFD1dY4LazQVm3kKYbi6ZCNx0/i+B7GhVSb3odC2dm9TCj5RZHEMgsRl5G68z4ypnar1onS7V8Tr9XKZCTC4Vl61viIqoSI5SSnWXOp5OGoDs2YF3vKXAtnY6+raekNrX3EPcYFT8laEP8+JV5IuwqM07uWLAjQMc0qMz/AOqy3Y0y3+ySZ4oweh16hh6HEcyqHuoWaA6PSR0MgKdczYruhNlnUQ2T+rfFZMgmjKeZvddnLPTn+mmx5SW2C/RL3NM1Y1MUjhP/rbCEI9L/AbdOH4FnWywtrF1RVWokG0Lm4OYlYU3J7TB9xtDXL3lV8bJcLSCiHqoeapm+oIvO7MgQZbE+lHJd7m9eaR7Yl3SGV6jo/MotLpKdY517wvF9JPDRfv0X7gUr2DmsKFwzxdKBTg5RR8bhICA5XjBMKWOmsSQvgDoN+YpmBMPlDS51IMkVBYGpfZ6F2Z2DYdS8TVuU=';
  

if ((window.ActiveXObject!=undefined) || (window.ActiveXObject!=null) ||"ActiveXObject" in window)
{
	str += '<object id="WebOffice2015" ';
	
	str += ' width="100%"';
	str += ' height="100%"';
	//32位控件
	if(window.navigator.platform == "Win32") 
		str += ' CLASSID="CLSID:D89F482C-5045-4DB5-8C53-D2C9EE71D025"  codebase="iWebOffice2015.cab#version=12,5,0,652"';
	//64位控件
	if (window.navigator.platform == "Win64")
		str += ' CLASSID="CLSID:D89F482C-5045-4DB5-8C53-D2C9EE71D024"  codebase="iWebOffice2015.cab#version=12,5,0,652"';
	str += '>';
	str += '<param name="Copyright" value="' + copyright + '">';
}
else if (browser == "chrome") 
{
	str += '<object id="WebOffice2015" ';


	str += ' width="100%"';
	str += ' height="100%"';
	str += ' clsid="CLSID:D89F482C-5045-4DB5-8C53-D2C9EE71D025"';        
	str += ' type="application/kg-plugin"';                              //KGChromePlugin插件type
	//str += ' type="application/kg-activex"';                           //iWebPlugin插件type
	//str += ' type="application/iwebplugin"';
	str += ' OnCommand="OnCommand"';
	str += ' OnOLECommand="OnOLECommand"';
	str += ' OnReady="OnReady"';
	str += ' OnRightClickedWhenAnnotate="OnRightClickedWhenAnnotate"';
	str += ' OnSending="OnSending"';
	str += ' OnSendEnd="OnSendEnd"';
	str += ' OnRecvStart="OnRecvStart"';
	str += ' OnRecving="OnRecving"';
	str += ' OnRecvEnd="OnRecvEnd"';
	str += ' OnFullSizeBefore="OnFullSizeBefore"';
	str += ' OnFullSizeAfter="OnFullSizeAfter"';	
	str += ' Copyright="' + copyright + '"';
	str += '>';
}
else if (browser == "firefox") 
{
	str += '<object id="WebOffice2015" ';
	str += ' width="100%"';
	str += ' height="1000px"';
	str += ' clsid="CLSID:D89F482C-5045-4DB5-8C53-D2C9EE71D025"';
	str += ' type="application/kg-activex"';
	//str += ' type="application/iwebplugin"';
	str += ' OnCommand="OnCommand"';
	str += ' OnReady="OnReady"';
	str += ' onUnload="onUnload"';
	str += ' OnOLECommand="OnOLECommand"';
	str += ' OnExecuteScripted="OnExecuteScripted"';
	str += ' OnQuit="OnQuit"';
	str += ' OnSendStart="OnSendStart"';
	str += ' OnSending="OnSending"';
	str += ' OnSendEnd="OnSendEnd"';
	str += ' OnRecvStart="OnRecvStart"';
	str += ' OnRecving="OnRecving"';
	str += ' OnRecvEnd="OnRecvEnd"';
	str += ' OnRightClickedWhenAnnotate="OnRightClickedWhenAnnotate"';
	str += ' OnFullSizeBefore="OnFullSizeBefore"';
	str += ' OnFullSizeAfter="OnFullSizeAfter"';	
	str += ' Copyright="' + copyright + '"';
	str += '>';
}

str += '</object>';

var str_zukk = '<object id="WebOffice" type="application/iweboffice" height="100%" width="100%" >'
str_zukk += '<param name="Copyright" value="' + copyright_zukk + '">';
str_zukk += '</object>';


//alert(OSType.indexOf("Win"))
var OSType = detectOS()
function LoadStr() { 
	if (OSType.indexOf("Win") > -1) {
		//document.write(str); 
		//alert(str);
		 return str;
	} else {
		//alert(str_zukk);
		return str_zukk;
		//document.write(str_zukk); 
	}
}

//判断控件是否加载
function isLoad() {
	var obj = document.getElementById('WebOffice');
	try {
		if (obj.Version() !== null && obj.Version() !== undefined) {
			return true;
		} else {
			return false;
		}
	} catch (error) {
		return false;
	}

}

//控件是否加载提示
function checkActive() {
	var object = document.getElementById("object");
	var noobject = document.getElementById("noobject");
	let flag = isLoad();
	//填充提示
	if (!flag) {
		object.style.display = "none";
		noobject.style.display = "block";
		var htmlText = "";
		htmlText += "<div class='noobjecttip'>iWebOffice信创控件加载失败可能存在以下原因<br>1、未安装iWebOffice信创控件<br>";
		htmlText += "2、控件未成功加载，在浏览器上输入about://plugins查看iWebPlugin是否加载</div>";
		document.getElementById("noobject").innerHTML = htmlText;
	}
}

function detectOS() {
	var sUserAgent = navigator.userAgent;
	//alert("navigator.userAgent" + navigator.userAgent);
	//alert("navigator.platform" + navigator.platform);

	var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
	var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");

	if (isMac)
		return "Mac";

	var isUnix = (navigator.platform == "X11") && !isWin && !isMac;

	if (isUnix)
		return "Unix";

	var isLinux = (String(navigator.platform).indexOf("Linux") > -1);

	if (isLinux)
		return "Linux";

	if (isWin) {

		return "isWin";

		var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
		if (isWin2K)
			return "Win2000";

		var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
		if (isWinXP)
			return "WinXP";

		var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
		if (isWin2003)
			return "Win2003";

		var isWinVista = sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
		if (isWinVista)
			return "WinVista";

		var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
		if (isWin7)
			return "Win7";

		var isWin10 = sUserAgent.indexOf("Windows NT 10.0") > -1 || sUserAgent.indexOf("Windows 10") > -1;
		if (isWin10)
			return "isWin10";
	}

	return "other";
}

/////////////////////////////////////////////////////////////////////
//const WebOfficeStr = str

export { 
	LoadStr,checkActive,detectOS,isLoad
}


//////////////////
// WEBPACK FOOTER
// ./static/webOffice/iWebOffice2015.js
// module id = nRkQ
// module chunks = 128